import { FC } from 'react';

import { Typography } from 'antd';

import { COLORS } from '../../../../../../../../../../../config/themes/colors';

interface TitleFamilyCoverageProps {
  titleFamily: any;
}

export const TitleFamilyCoverage: FC<TitleFamilyCoverageProps> = ({ titleFamily }) => {
    
  return (
    <Typography.Title
      level={4}
      style={{
        margin: 0,
        marginBottom: 0,
        color: COLORS.secondary[100],
      }}
    >
      {titleFamily}
    </Typography.Title>
  );
};
